<template>
    <div class="row">
        <div class="col-12 mb-1">
            <b-alert show variant="info" class="mb-1">
                <div class="d-flex align-items-start">
                    <feather-icon icon="InfoIcon" class="mr-50 mt-25"></feather-icon>
                    <div>
                        Önce ilgili ay/yıl için <strong>Excel İndir</strong> ile şablonu alın, doldurulacak kolonları
                        girin ve yükleyin. Eşleştirme <strong>TC</strong> ve seçtiğiniz <strong>ay/yıl</strong> ile yapılır;
                        <strong>TC</strong> kolonuna dokunmayın.
                    </div>
                </div>
            </b-alert>

            <b-button v-b-toggle.man-allowance-column-order size="sm" variant="outline-secondary" class="mb-1">
                <feather-icon icon="ListIcon" class="mr-50"></feather-icon>
                Şablon kolon sırası
            </b-button>
            <b-collapse id="man-allowance-column-order">
                <div class="border rounded p-1 mb-1">
                    <p class="mb-50 text-muted small">
                        <span class="text-warning font-weight-bold">Sarı</span> işaretli kolonları siz doldurursunuz; diğerleri sistemden gelir.
                    </p>
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered mb-0">
                            <thead>
                                <tr><th style="width:60px">Sıra</th><th>Kolon</th></tr>
                            </thead>
                            <tbody>
                                <tr v-for="col in columnOrder" :key="col.index" :class="col.fill ? 'table-warning' : ''">
                                    <td class="text-center">{{ col.index }}</td>
                                    <td>{{ col.name }}<span v-if="col.fill" class="text-muted small"> (doldurulacak)</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </b-collapse>

            <label class="form-label">Excel</label>
            <v-file-uploader v-model="value" :accept="['xlsx','xls']" value-parameter="File"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
export default {
    components: {
        VFileUploader
    },
    props: {
        value: Object
    },
    data() {
        return {
            // Referans "Ek Hakediş Yükleme Ekranı (Man)" sekmesi (11 kolon). fill=true => doldurulan + upload'ın okuduğu kolonlar.
            columnOrder: [
                { index: 1, name: 'Sıra' },
                { index: 2, name: 'Adı Soyadı' },
                { index: 3, name: 'TC' },
                { index: 4, name: 'Unvan' },
                { index: 5, name: 'Şube [Fiili]' },
                { index: 6, name: 'FMÜ [Fazla Mesai Ücreti]', fill: true },
                { index: 7, name: 'FMÜ [Bayram] [Fazla Mesai Ücreti Bayram]', fill: true },
                { index: 8, name: 'Yemek Ücreti', fill: true },
                { index: 9, name: 'Yol Ücreti', fill: true },
                { index: 10, name: 'ODÖ [Olağandışı Ödemeler]', fill: true },
                { index: 11, name: 'Açıklama', fill: true },
            ]
        }
    }
}
</script>
